import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';


const PendingClinicAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM YYYY')}
    icon={<BarnyardIcon icon={['fa', 'user-md']} className='DiscussCard__replyIcon' />}
    title={(
      <div>
        <Link to='/corporate/settings/pending-clinics'>
          {alert.buyer.name}
        </Link>
        {' '} is pending approval
      </div>
    )}
    {...other}
  />
);

PendingClinicAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default PendingClinicAlert;
